import { TFunction } from 'i18next';
import { InvoicingException } from '../interface/common';

export function showErrorMessage(
  apiErrorException: string,
  isPreInvoiceCreation: boolean,
  setIsError: (isError: boolean) => void,
  setErrorMessage: (message: string) => void,
  t: TFunction,
) {
  const setErrorMessageWithTimeout = (message: string) => {
    setTimeout(() => {
      setIsError(true);
      setErrorMessage(message);
    }, 300);
  };

  switch (apiErrorException) {
    case InvoicingException.MatterHasIncompleteTransactionsException:
      setErrorMessageWithTimeout(
        isPreInvoiceCreation
          ? t(
              'matter:createPreliminaryInvoiceError.matterHasIncompleteTransactionsNewPreliminaryInvoiceCannotBeCreated',
            )
          : t(
              'matter:createPreliminaryInvoiceError.matterHasIncompleteTransactionsNewInvoiceCannotBeCreated',
            ),
      );
      break;
    case InvoicingException.MatterHasNoInvoiceableTransactionsOrExpensesException:
      setErrorMessageWithTimeout(
        t(
          'matter:createPreliminaryInvoiceError.matterHasNoInvoiceableTransactionsOrExpensesNewPreliminaryInvoiceCannotBeCreated',
        ),
      );
      break;
    case InvoicingException.MatterHasOpenPreliminaryInvoiceAlreadyException:
      setErrorMessageWithTimeout(
        isPreInvoiceCreation
          ? t(
              'matter:createPreliminaryInvoiceError.matterHasExistingUninvoicedPreliminaryInvoiceNewPreliminaryInvoiceCannotBeCreated',
            )
          : t(
              'matter:createPreliminaryInvoiceError.matterHasExistingUninvoicedPreliminaryInvoiceNewInvoiceCannotBeCreated',
            ),
      );
      break;
    case InvoicingException.FiscalPeriodDoesNotExistsException:
      setErrorMessageWithTimeout(
        isPreInvoiceCreation
          ? t(
              'matter:createPreliminaryInvoiceError.fiscalPeriodNotOpenForPreliminaryInvoiceEntryDate',
            )
          : t('matter:createPreliminaryInvoiceError.fiscalPeriodNotOpenForInvoiceEntryDate'),
      );
      break;
    case InvoicingException.PrincipalIsNotIdentifiedException:
      setErrorMessageWithTimeout(
        isPreInvoiceCreation
          ? t(
              'matter:createPreliminaryInvoiceError.principalRequiresIdentificationPreliminaryInvoice',
            )
          : t('matter:createPreliminaryInvoiceError.principalRequiresIdentificationInvoice'),
      );
      break;
    case InvoicingException.TransactionPostingPeriodDoesNotExistException:
      setErrorMessageWithTimeout(
        t('matter:createPreliminaryInvoiceError.transactionPostingPeriodDoesNotExist'),
      );
      break;
    case InvoicingException.MatterNotFoundException:
      setErrorMessageWithTimeout(t('matter:createPreliminaryInvoiceError.selectedMatterNotFound'));
      break;
    case InvoicingException.MatterIsOrHasSubMatterException:
    case InvoicingException.MatterHasSubMattersException:
      setErrorMessageWithTimeout(
        isPreInvoiceCreation
          ? t(
              'matter:createPreliminaryInvoiceError.matterHasSubMattersNewPreliminaryInvoiceCannotBeCreated',
            )
          : t('matter:createPreliminaryInvoiceError.matterHasSubMattersNewInvoiceCannotBeCreated'),
      );
      break;
    case InvoicingException.MatterIsSubMatterException:
      setErrorMessageWithTimeout(
        isPreInvoiceCreation
          ? t(
              'matter:createPreliminaryInvoiceError.matterIsSubMatterNewPreliminaryInvoiceCannotBeCreated',
            )
          : t('matter:createPreliminaryInvoiceError.matterIsSubMatterNewInvoiceCannotBeCreated'),
      );
      break;
    case InvoicingException.PayerHasDiscountTableException:
      setErrorMessageWithTimeout(
        t('matter:createPreliminaryInvoiceError.oneOrMorePayersHasDiscountTableNotSupported'),
      );
      break;
    case InvoicingException.MatterIsNotInvoiceableException:
      setErrorMessageWithTimeout(
        t(
          'matter:createPreliminaryInvoiceError.matterIsNotInvoiceableNewPreliminaryInvoiceCannotBeCreated',
        ),
      );
      break;
    case InvoicingException.InvoicingPeriodIsNotInUseException:
      setErrorMessageWithTimeout(
        t('matter:createPreliminaryInvoiceError.invoicingPeriodIsNotInUse'),
      );
      break;
    case InvoicingException.UserHasNoPermissionToPreliminaryInvoiceException:
      setErrorMessageWithTimeout(
        t('matter:createPreliminaryInvoiceError.userHasNoRightsToCreatePreliminaryInvoice'),
      );
      break;
    default:
      setErrorMessageWithTimeout(t('common:somethingWentWrongTryAgain'));
      break;
  }
}
